import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import ReactHtmlParser from "react-html-parser";
import {withRouter, Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {getCurrentUserProfile, updateCurrentuserProfile} from '../../actions';
import {getSchoolsDropdown} from '../../../Schools/actions';
import roles from '../../../Auth/userRoles';
import {MIN_PASSWORD_STRENGTH} from '../../../Auth/passwordConfig';
import SectionTitle from '../../../Layout/components/SectionTitle';
import LoadingSpinner from '../../../Layout/components/LoadingSpinner';
import {truncateText} from '../../../../app/utils/text';
import classnames from 'classnames';
import validator from 'validator';
import zxcvbn from 'zxcvbn';
import moment from 'moment';
import 'moment/min/locales';
import 'moment/locale/fr';
import 'moment/locale/en-gb';
import momentDurationFormat from "moment-duration-format";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import SmartphoneIcon from '@material-ui/icons/Smartphone';
import TabletIcon from '@material-ui/icons/Tablet';
import DesktopIcon from '@material-ui/icons/DesktopWindows';
import LaptopIcon from '@material-ui/icons/Laptop';
import DevicesOtherIcon from '@material-ui/icons/DevicesOther';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {withLocalize, Translate, getActiveLanguage} from 'react-localize-redux';
import translations from '../../translations/translations_profile';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

class DashboardProfileContainer extends Component {
    state = {
        errors: {},
        openSnackbarSuccess: false,
        expanded: null,
        current_password: '',
        new_password: '',
        new_password_confirmation: '',
        new_password_strength_score: null,
        new_password_strength_note: '',
        first_name: '',
        last_name: '',
        email: '',
        description: '',
        address_line1: '',
        address_line2: '',
        address_postal_code: '',
        address_city: '',
        billing_address_type: 'personal',
        billing_address_name: '',
        billing_address_line1: '',
        billing_address_line2: '',
        billing_address_postal_code: '',
        billing_address_city: '',
        employer: '',
        employer_other: '',
        fonction: '',
        roles: [],
        role_other: '',
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        this.props.getCurrentUserProfile();
        this.props.getSchoolsDropdown();
    }

    componentDidUpdate(prevProps, prevState) {
        const {profile, profileLoading, profileErrors, profileUpdated, updateProfileLoading} = this.props.dashboard;

        if (profileLoading === false && profileErrors === null && profile !== null && prevProps.dashboard.profile !== profile) {
            let newRoles = [];

            if (profile.roles['agep-antenne']) {
                newRoles.push('agep-antenne');
            }
            if (profile.roles['agep-direction']) {
                newRoles.push('agep-direction');
            }
            if (profile.roles['agep-intervenant']) {
                newRoles.push('agep-intervenant');
            }
            if (profile.roles['agep-enseignant']) {
                newRoles.push('agep-enseignant');
            }
            if (profile.roles['agep-dip']) {
                newRoles.push('agep-dip');
            }
            if (profile.roles['agep-autre']) {
                newRoles.push('agep-autre');
            }

            this.setState({
                first_name: profile.first_name,
                last_name: profile.last_name,
                email: profile.email,
                description: profile.description,
                address_line1: profile.address.line1,
                address_line2: profile.address.line2,
                address_postal_code: profile.address.postal_code,
                address_city: profile.address.city,
                billing_address_type: profile.billing.address_type,
                billing_address_name: profile.billing.address_name,
                billing_address_line1: profile.billing.line1,
                billing_address_line2: profile.billing.line2,
                billing_address_postal_code: profile.billing.postal_code,
                billing_address_city: profile.billing.city,
                employer: profile.employer.school,
                employer_other: profile.employer.other,
                fonction: profile.employer.fonction,
                roles: newRoles,
                role_other: profile.roles.other,
            });
        }

        if (prevProps.dashboard.updateProfileLoading !== updateProfileLoading) {
            this.setState({
                openSnackbarSuccess: (profileUpdated === true),
            });
        }

        if (prevProps.errors !== this.props.errors) {
            this.setState({
                errors: this.props.errors,
            });
        }
    }

    handleChangePanel = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    handleChange = name => e => {
        const value = (e.target.type === 'checkbox') ? e.target.checked : e.target.value;

        this.setState({
            [name]: value,
        }, () => this.validateFieldsAndDisplayErrors([name]));
    };

    handleFormSubmit = panel => e => {
        e.preventDefault();

        let userData = {};

        switch (panel) {
            case 'panel10':
                userData = {
                    first_name: this.state.first_name,
                    last_name: this.state.last_name,
                };
                break;
            case 'panel11':
                userData = {
                    roles: this.state.roles,
                    role_other: this.state.role_other,
                };
                break;
            case 'panel12':
                userData = {
                    description: this.state.description,
                };
                break;
            case 'panel13':
                userData = {
                    email: this.state.email,
                };
                break;
            case 'panel14':
                userData = {
                    address_line1: this.state.address_line1,
                    address_line2: this.state.address_line2,
                    address_postal_code: this.state.address_postal_code,
                    address_city: this.state.address_city,
                };
                break;
            case 'panel15':
                userData = {
                    billing_address_name: this.state.billing_address_name,
                    billing_address_type: this.state.billing_address_type,
                    billing_address_line1: this.state.billing_address_line1,
                    billing_address_line2: this.state.billing_address_line2,
                    billing_address_postal_code: this.state.billing_address_postal_code,
                    billing_address_city: this.state.billing_address_city,
                };
                break;
            case 'panel20':
                userData = {
                    employer: this.state.employer,
                    employer_other: this.state.employer_other,
                };
                break;
            case 'panel22':
                userData = {
                    fonction: this.state.fonction,
                };
                break;
            case 'panel30':
                userData = {
                    current_password: this.state.current_password,
                    new_password: this.state.new_password,
                    new_password_confirmation: this.state.new_password_confirmation,

                    // Required to get the strength of the password
                    first_name: this.state.first_name,
                    last_name: this.state.last_name,
                    email: this.state.email,
                };
                break;
            default:
                break;
        }

        this.props.updateCurrentuserProfile(panel, userData);
    };

    handleCloseSnackbar = (e) => {
        this.setState({
            openSnackbarSuccess: false
        });
    };

    displayFullAddress() {
        let address = '';
        let separator = ', ';

        if (this.state.address_line1 !== '') {
            address += this.state.address_line1 + separator;
        }
        if (this.state.address_line2 !== '') {
            address += this.state.address_line2 + separator;
        }
        if (this.state.address_postal_code !== '') {
            address += this.state.address_postal_code + ' ';
        }
        if (this.state.address_city !== '') {
            address += this.state.address_city + separator;
        }

        address = address.replace(/,\s*$/, ""); // Remove last comma

        return validator.escape(address);
    }

    displayRoleString() {
        const selected = this.state.roles;
        let titles = [];

        selected.forEach(function(key) {
            let role = roles.find(role => role.id === key);
            if (role) {
                titles.push(role.title);
            }
        });

        return (
            <Fragment>{titles.join(', ')}</Fragment>
        );
    }

    displaySchoolName() {
        const {schoolsDropdown, schoolsDropdownLoading} = this.props.schools;
        const employer = this.state.employer;

        let name = '';

        if (employer === 0 || employer === '') {
            name = validator.escape(this.state.employer_other);
        } else {
            if ((Array.isArray(schoolsDropdown) && schoolsDropdown.length > 0) && !schoolsDropdownLoading) {
                schoolsDropdown.map(function(school) {
                    if (school.id === employer) {
                        name = school.title;
                    }
                });
            }
        }

        return ReactHtmlParser(name);
    }

    validateFieldsAndDisplayErrors = (fields = []) => {
        const {errors} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};
        let hasErrors = false;

        for (let i = 0, len = fields.length; i < len; i++) {
            let error = this.validateField(fields[i]);

            if (error !== null) {
                hasErrors = true;
            }

            errorsData[fields[i]] = error;
        }

        this.setState({
            errors: {
                ...errors,
                data: errorsData,
            }
        });

        return hasErrors;
    };

    validateField = (field) => {
        let error = null;

        switch (field) {
            case 'email':
                if (!validator.isEmail(this.state.email)) {
                    error = 'validate_email_required';
                }
                break;
            case 'first_name':
                if (validator.isEmpty(this.state.first_name)) {
                    error = 'validate_firstname_required';
                } else if (this.state.first_name.length <= 2) {
                    error = 'validate_firstname_too_short';
                } else {
                    if (!this.state.first_name.match(/^[A-Za-zÀ-ÿ0-9- ]*$/)) {
                        error = 'validate_firstname_letters';
                    }
                }
                break;
            case 'last_name':
                if (validator.isEmpty(this.state.last_name)) {
                    error = 'validate_lastname_required';
                } else if (this.state.last_name.length <= 2) {
                    error = 'validate_lastname_too_short';
                } else {
                    if (!this.state.last_name.match(/^[A-Za-zÀ-ÿ0-9- ]*$/)) {
                        error = 'validate_lastname_letters';
                    }
                }
                break;
            case 'description':
                if (this.state.last_name.length > 2000) {
                    error = 'validate_biography_too_long';
                }
                break;
            case 'fonction':
                if (this.state.fonction.length > 200) {
                    error = 'validate_job_too_long';
                } else {
                    if (!this.state.fonction.match(/^[A-Za-zÀ-ÿ0-9- ]*$/)) {
                        error = 'validate_job_letters';
                    }
                }
                break;
            case 'roles':
                if (!Array.isArray(this.state.roles) || (Array.isArray(this.state.roles) && this.state.roles.length === 0)) {
                    error = 'validate_role_required';
                }
                break;
            case 'employer':
                if (!Number.isInteger(this.state.employer)) {
                    error = 'validate_employer_required';
                }
                break;
            case 'current_password':
                if (validator.isEmpty(this.state.current_password)) {
                    error = 'validate_current_password_required';
                }
                break;
            case 'new_password':
                if (validator.isEmpty(this.state.new_password)) {
                    error = 'validate_new_password_required';
                } else {
                    let note = '';
                    const strength = zxcvbn(this.state.new_password, [this.state.first_name, this.state.last_name, this.state.email]);

                    if (strength.score < MIN_PASSWORD_STRENGTH) {
                        error = 'validate_stronger_password';
                    }

                    switch (strength.score) {
                        case 0:
                        case 1:
                            note = 'validate_password_strength_weak';
                            break;
                        case 2:
                            note = 'validate_password_strength_soso';
                            break;
                        case 3:
                            note = 'validate_password_strength_good';
                            break;
                        case 4:
                            note = 'validate_password_strength_great';
                            break;
                        default:
                            break;
                    }

                    this.setState({
                        new_password_strength_score: strength.score,
                        new_password_strength_note: note,
                    });
                }
                break;
            case 'new_password_confirmation':
                if (validator.isEmpty(this.state.new_password_confirmation)) {
                    error = 'validate_confirmation_password_required';
                } else {
                    if (!validator.equals(this.state.new_password, this.state.new_password_confirmation)) {
                        error = 'validate_confirmation_password_match';
                    }
                }
                break;
            case 'address_line1':
                if (validator.isEmpty(this.state.address_line1)) {
                    error = 'validate_address_line1_required';
                }
                break;
            case 'address_postal_code':
                if (validator.isEmpty(this.state.address_postal_code)) {
                    error = 'validate_postal_code_required';
                } else if (this.state.address_postal_code.length > 10) {
                    error = 'validate_postal_code_too_long';
                } else if (this.state.address_postal_code.length <= 2) {
                    error = 'validate_postal_code_too_short';
                }
                break;
            case 'address_city':
                if (validator.isEmpty(this.state.address_city)) {
                    error = 'validate_city_required';
                }
                break;
            case 'billing_address_name':
                if (this.state.billing_address_name.length > 100) {
                    error = 'validate_billing_address_name_too_long';
                }
                break;
            case 'billing_address_line1':
                if (validator.isEmpty(this.state.billing_address_line1)) {
                    error = 'validate_billing_address_line1_required';
                }
                break;
            case 'billing_address_postal_code':
                if (validator.isEmpty(this.state.billing_address_postal_code)) {
                    error = 'validate_billing_postal_code_required';
                } else if (this.state.billing_address_postal_code.length > 10) {
                    error = 'validate_billing_postal_code_too_long';
                } else if (this.state.billing_address_postal_code.length <= 2) {
                    error = 'validate_billing_postal_code_too_short';
                }
                break;
            case 'billing_address_city':
                if (validator.isEmpty(this.state.billing_address_city)) {
                    error = 'validate_billing_city_required';
                }
                break;
            default:
                break;
        }
        
        return error;
    };

    render() {
        const {currentLanguage} = this.props;
        const {profile, profileLoading, profileErrors, profileUpdated, updateProfileLoading} = this.props.dashboard;
        const {schoolsDropdown, schoolsDropdownLoading} = this.props.schools;
        const {expanded, errors, new_password_strength_score, new_password_strength_note} = this.state;
        const errorsData = (errors.hasOwnProperty('data')) ? errors.data : {};

        const pageTitle = this.props.translate('dashboard_profile.page_title') + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        momentDurationFormat(moment);
        moment.locale(currentLanguage);

        const dateFormat = this.props.translate('dashboard_profile.date_format');

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'dashboard dashboard-profile'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <SectionTitle cssClass="page-title"
                                  title={this.props.translate('dashboard_profile.page_title')}
                                  subtitle={this.props.translate('dashboard_profile.page_description')}
                    />

                    <div className="mt-90 mb-90">
                        {((profileLoading || profileErrors !== null || profile === null) || (Array.isArray(schoolsDropdown) && schoolsDropdown.length === 0 || schoolsDropdownLoading)) ? (
                            <LoadingSpinner align="center" />
                        ) : (
                            <Fragment>
                                <section className="section-setting mb-60">
                                    <h2 className="title"><Translate id="dashboard_profile.title_about_you" /></h2>

                                    <ExpansionPanel expanded={expanded === 'panel10'} onChange={this.handleChangePanel('panel10')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel10'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_identity" /></Typography>
                                            <Typography className="panel-secondary-heading">
                                                {validator.escape(this.state.first_name)} {validator.escape(this.state.last_name)}
                                            </Typography>
                                        </ExpansionPanelSummary>
                                        <form autoComplete="off" onSubmit={this.handleFormSubmit('panel10')}>
                                            <ExpansionPanelDetails className="panel-details">
                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.first_name ? true : false}>
                                                    <InputLabel htmlFor="first_name" className="form-label">
                                                        <Translate id="dashboard_profile.field_firstname" /> *
                                                    </InputLabel>
                                                    <Input id="first_name" value={this.state.first_name} onChange={this.handleChange('first_name')} className="form-input" />
                                                    {errorsData.first_name && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.first_name)}</FormHelperText>)}
                                                </FormControl>
                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.last_name ? true : false}>
                                                    <InputLabel htmlFor="last_name" className="form-label">
                                                        <Translate id="dashboard_profile.field_lastname" /> *
                                                    </InputLabel>
                                                    <Input id="last_name" value={this.state.last_name} onChange={this.handleChange('last_name')} className="form-input" />
                                                    {errorsData.last_name && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.last_name)}</FormHelperText>)}
                                                </FormControl>
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                {updateProfileLoading ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" disabled={updateProfileLoading}>
                                                        <Translate id="dashboard_profile.button_update" />
                                                    </Button>
                                                )}
                                            </ExpansionPanelActions>
                                        </form>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panel11'} onChange={this.handleChangePanel('panel11')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel11'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_role" /></Typography>
                                            <Typography className="panel-secondary-heading">{this.displayRoleString()}</Typography>
                                        </ExpansionPanelSummary>
                                        <form autoComplete="off" onSubmit={this.handleFormSubmit('panel11')}>
                                            <ExpansionPanelDetails className="panel-details">
                                                <FormControl className="form-control" fullWidth={true} margin="normal"  error={errorsData.roles ? true : false}>
                                                    <InputLabel htmlFor="select-multiple-checkbox">
                                                        <Translate id="dashboard_profile.field_you_are" /> *
                                                    </InputLabel>
                                                    <Select
                                                        multiple
                                                        id="roles"
                                                        value={this.state.roles}
                                                        onChange={this.handleChange('roles')}
                                                        input={<Input id="select-multiple-checkbox" />}
                                                        renderValue={function (selected) {
                                                            let titles = [];

                                                            selected.forEach(function(key) {
                                                                let role = roles.find(role => role.id === key);
                                                                if (role) {
                                                                    titles.push(role.title);
                                                                }
                                                            });

                                                            return (
                                                                <Fragment>{titles.join(', ')}</Fragment>
                                                            );
                                                        }}
                                                        MenuProps={MenuProps}
                                                    >
                                                        {roles.map(role => (
                                                            <MenuItem key={role.id} value={role.id}>
                                                                <Checkbox checked={this.state.roles.indexOf(role.id) > -1} />
                                                                <ListItemText primary={role.title} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>

                                                {this.state.roles.indexOf('other') > -1 &&
                                                    <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.role_other ? true : false}>
                                                        <InputLabel htmlFor="role_other" className="form-label">
                                                            <Translate id="dashboard_profile.field_other_role" /> *
                                                        </InputLabel>
                                                        <Input id="role_other" value={this.state.role_other} onChange={this.handleChange('role_other')} className="form-input" />
                                                        {errorsData.role_other && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.role_other)}</FormHelperText>)}
                                                    </FormControl>
                                                }
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                {updateProfileLoading ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" disabled={updateProfileLoading}>
                                                        <Translate id="dashboard_profile.button_update" />
                                                    </Button>
                                                )}
                                            </ExpansionPanelActions>
                                        </form>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panel12'} onChange={this.handleChangePanel('panel12')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel12'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_bio" /></Typography>
                                            <Typography className="panel-secondary-heading">
                                                {truncateText(validator.escape(this.state.description), 30)}
                                            </Typography>
                                        </ExpansionPanelSummary>
                                        <form autoComplete="off" onSubmit={this.handleFormSubmit('panel12')}>
                                            <ExpansionPanelDetails className="panel-details">
                                                <Typography>
                                                    <i><Translate id="dashboard_profile.biographical_notice" /></i>
                                                </Typography>
                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.description ? true : false}>
                                                    <TextField  id="message" value={this.state.description} onChange={this.handleChange('description')} className="form-input" multiline rows={3} rowsMax={8} />
                                                    {errorsData.description && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.description)}</FormHelperText>)}
                                                </FormControl>
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                {updateProfileLoading ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" disabled={updateProfileLoading}>
                                                        <Translate id="dashboard_profile.button_update" />
                                                    </Button>
                                                )}
                                            </ExpansionPanelActions>
                                        </form>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panel13'} onChange={this.handleChangePanel('panel13')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel13'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_email" /></Typography>
                                            <Typography className="panel-secondary-heading">{validator.escape(this.state.email)}</Typography>
                                        </ExpansionPanelSummary>
                                        <form autoComplete="off" onSubmit={this.handleFormSubmit('panel13')}>
                                            <ExpansionPanelDetails className="panel-details">
                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.email ? true : false}>
                                                    <InputLabel htmlFor="email" className="form-label">
                                                        <Translate id="dashboard_profile.field_email" /> *
                                                    </InputLabel>
                                                    <Input id="email" value={this.state.email} onChange={this.handleChange('email')} className="form-input" />
                                                    {errorsData.email && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.email)}</FormHelperText>)}
                                                </FormControl>
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                {updateProfileLoading ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" disabled={updateProfileLoading}>
                                                        <Translate id="dashboard_profile.button_update" />
                                                    </Button>
                                                )}
                                            </ExpansionPanelActions>
                                        </form>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panel14'} onChange={this.handleChangePanel('panel14')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel14'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_personal_address" /></Typography>
                                            <Typography className="panel-secondary-heading">{this.displayFullAddress()}</Typography>
                                        </ExpansionPanelSummary>
                                        <form autoComplete="off" onSubmit={this.handleFormSubmit('panel14')}>
                                            <ExpansionPanelDetails className="panel-details">
                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_line1 ? true : false}>
                                                    <InputLabel htmlFor="address_line1" className="form-label">
                                                        <Translate id="dashboard_profile.field_address_line1" /> *
                                                    </InputLabel>
                                                    <Input id="address_line1" value={this.state.address_line1} onChange={this.handleChange('address_line1')} className="form-input" />
                                                    {errorsData.address_line1 && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.address_line1)}</FormHelperText>)}
                                                </FormControl>

                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_line2 ? true : false}>
                                                    <InputLabel htmlFor="address_line2" className="form-label">
                                                        <Translate id="dashboard_profile.field_address_line2" />
                                                    </InputLabel>
                                                    <Input id="address_line2" value={this.state.address_line2} onChange={this.handleChange('address_line2')} className="form-input" />
                                                    {errorsData.address_line2 && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.address_line2)}</FormHelperText>)}
                                                </FormControl>

                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_postal_code ? true : false}>
                                                    <InputLabel htmlFor="address_postal_code" className="form-label">
                                                        <Translate id="dashboard_profile.field_address_postal_code" /> *
                                                    </InputLabel>
                                                    <Input id="address_postal_code" value={this.state.address_postal_code} onChange={this.handleChange('address_postal_code')} className="form-input" />
                                                    {errorsData.address_postal_code && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.address_postal_code)}</FormHelperText>)}
                                                </FormControl>

                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.address_city ? true : false}>
                                                    <InputLabel htmlFor="address_city" className="form-label">
                                                        <Translate id="dashboard_profile.field_address_city" /> *
                                                    </InputLabel>
                                                    <Input id="address_city" value={this.state.address_city} onChange={this.handleChange('address_city')} className="form-input" />
                                                    {errorsData.address_city && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.address_city)}</FormHelperText>)}
                                                </FormControl>
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                {updateProfileLoading ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" disabled={updateProfileLoading}>
                                                        <Translate id="dashboard_profile.button_update" />
                                                    </Button>
                                                )}
                                            </ExpansionPanelActions>
                                        </form>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panel15'} onChange={this.handleChangePanel('panel15')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel15'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_billing_address" /></Typography>
                                            <Typography className="panel-secondary-heading">
                                                {this.state.billing_address_type === 'personal' && <Translate id="dashboard_profile.field_billing_address_type_personal" />}
                                                {this.state.billing_address_type === 'school' && <Translate id="dashboard_profile.field_billing_address_type_school" />}
                                                {this.state.billing_address_type === 'other' && <Translate id="dashboard_profile.field_billing_address_type_other" />}
                                            </Typography>
                                        </ExpansionPanelSummary>
                                        <form autoComplete="off" onSubmit={this.handleFormSubmit('panel15')}>
                                            <ExpansionPanelDetails className="panel-details">
                                                <FormControl className="form-control" fullWidth={true} margin="normal">
                                                    <InputLabel htmlFor="billing_address_type">
                                                        <Translate id="dashboard_profile.field_billing_address_type" />
                                                    </InputLabel>
                                                    <Select
                                                        id="billing_address_type"
                                                        value={this.state.billing_address_type}
                                                        onChange={this.handleChange('billing_address_type')}
                                                        inputProps={{
                                                            name: 'billing_address_type',
                                                            id: 'billing_address_type',
                                                        }}
                                                    >
                                                        <MenuItem value="personal"><Translate id="dashboard_profile.field_billing_address_type_personal" /></MenuItem>
                                                        <MenuItem value="school"><Translate id="dashboard_profile.field_billing_address_type_school" /></MenuItem>
                                                        <MenuItem value="other"><Translate id="dashboard_profile.field_billing_address_type_other" /></MenuItem>
                                                    </Select>
                                                </FormControl>
                                                {this.state.billing_address_type === 'other'  &&
                                                    <Fragment>
                                                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.billing_address_name ? true : false}>
                                                            <InputLabel htmlFor="billing_address_name" className="form-label">
                                                                <Translate id="dashboard_profile.field_billing_address_name" />
                                                            </InputLabel>
                                                            <Input id="billing_address_name" value={this.state.billing_address_name} onChange={this.handleChange('billing_address_name')} className="form-input" />
                                                            {errorsData.billing_address_name && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.billing_address_name)}</FormHelperText>)}
                                                        </FormControl>

                                                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.billing_address_line1 ? true : false}>
                                                            <InputLabel htmlFor="billing_address_line1" className="form-label">
                                                                <Translate id="dashboard_profile.field_billing_address_line1" /> *
                                                            </InputLabel>
                                                            <Input id="billing_address_line1" value={this.state.billing_address_line1} onChange={this.handleChange('billing_address_line1')} className="form-input" />
                                                            {errorsData.billing_address_line1 && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.billing_address_line1)}</FormHelperText>)}
                                                        </FormControl>

                                                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.billing_address_line2 ? true : false}>
                                                            <InputLabel htmlFor="billing_address_line2" className="form-label">
                                                                <Translate id="dashboard_profile.field_billing_address_line2" />
                                                            </InputLabel>
                                                            <Input id="billing_address_line2" value={this.state.billing_address_line2} onChange={this.handleChange('billing_address_line2')} className="form-input" />
                                                            {errorsData.billing_address_line2 && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.billing_address_line2)}</FormHelperText>)}
                                                        </FormControl>

                                                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.billing_address_postal_code ? true : false}>
                                                            <InputLabel htmlFor="billing_address_postal_code" className="form-label">
                                                                <Translate id="dashboard_profile.field_billing_address_postal_code" /> *
                                                            </InputLabel>
                                                            <Input id="billing_address_postal_code" value={this.state.billing_address_postal_code} onChange={this.handleChange('billing_address_postal_code')} className="form-input" />
                                                            {errorsData.billing_address_postal_code && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.billing_address_postal_code)}</FormHelperText>)}
                                                        </FormControl>

                                                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.billing_address_city ? true : false}>
                                                            <InputLabel htmlFor="billing_address_city" className="form-label">
                                                                <Translate id="dashboard_profile.field_billing_address_city" /> *
                                                            </InputLabel>
                                                            <Input id="billing_address_city" value={this.state.billing_address_city} onChange={this.handleChange('billing_address_city')} className="form-input" />
                                                            {errorsData.billing_address_city && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.billing_address_city)}</FormHelperText>)}
                                                        </FormControl>
                                                    </Fragment>
                                                }
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                {updateProfileLoading ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" disabled={updateProfileLoading}>
                                                        <Translate id="dashboard_profile.button_update" />
                                                    </Button>
                                                )}
                                            </ExpansionPanelActions>
                                        </form>
                                    </ExpansionPanel>
                                </section>
                                <section className="section-setting mb-60">
                                    <h2 className="title"><Translate id="dashboard_profile.title_employer" /></h2>
                                    <ExpansionPanel expanded={expanded === 'panel20'} onChange={this.handleChangePanel('panel20')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel20'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_school" /></Typography>
                                            <Typography className="panel-secondary-heading">{this.displaySchoolName()}</Typography>
                                        </ExpansionPanelSummary>
                                        <form autoComplete="off" onSubmit={this.handleFormSubmit('panel20')}>
                                            <ExpansionPanelDetails className="panel-details">
                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.employer ? true : false}>
                                                    <InputLabel htmlFor="employer"><Translate id="dashboard_profile.field_employer" /> *</InputLabel>
                                                    <Select
                                                        id="employer"
                                                        value={this.state.employer}
                                                        onChange={this.handleChange('employer')}
                                                        inputProps={{
                                                            name: 'employer',
                                                        }}
                                                    >
                                                        {!schoolsDropdownLoading && schoolsDropdown.map(school => (
                                                            <MenuItem key={school.id} value={school.id}>{ReactHtmlParser(school.title)}</MenuItem>
                                                        ))}
                                                        <MenuItem key="0" value={0}>
                                                            <Translate id="dashboard_profile.field_employer_item_other" />
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>

                                                {this.state.employer === 0  &&
                                                    <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.employer_other ? true : false}>
                                                        <InputLabel htmlFor="employer_other" className="form-label">
                                                            <Translate id="dashboard_profile.field_employer_other" />
                                                        </InputLabel>
                                                        <Input id="employer_other" value={this.state.employer_other} onChange={this.handleChange('employer_other')} className="form-input" />
                                                        {errorsData.employer_other && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.employer_other)}</FormHelperText>)}
                                                    </FormControl>
                                                }
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                {updateProfileLoading ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" disabled={updateProfileLoading}>
                                                        <Translate id="dashboard_profile.button_update" />
                                                    </Button>
                                                )}
                                            </ExpansionPanelActions>
                                        </form>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panel21'} onChange={this.handleChangePanel('panel21')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel21'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_school_address" /></Typography>
                                            <Typography className="panel-secondary-heading"></Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails className="panel-details">
                                            <Typography>
                                                <Translate id="dashboard_profile.notice_school_address" />
                                            </Typography>
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panel22'} onChange={this.handleChangePanel('panel22')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel22'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_school_job" /></Typography>
                                            <Typography className="panel-secondary-heading">{validator.escape(this.state.fonction)}</Typography>
                                        </ExpansionPanelSummary>
                                        <form autoComplete="off" onSubmit={this.handleFormSubmit('panel22')}>
                                            <ExpansionPanelDetails className="panel-details">
                                                <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.fonction ? true : false}>
                                                    <InputLabel htmlFor="fonction" className="form-label">
                                                        <Translate id="dashboard_profile.field_fonction" />
                                                    </InputLabel>
                                                    <Input id="fonction" value={this.state.fonction} onChange={this.handleChange('fonction')} className="form-input" />
                                                    {errorsData.fonction && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.fonction)}</FormHelperText>)}
                                                </FormControl>
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                {updateProfileLoading ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" disabled={updateProfileLoading}>
                                                        <Translate id="dashboard_profile.button_update" />
                                                    </Button>
                                                )}
                                            </ExpansionPanelActions>
                                        </form>
                                    </ExpansionPanel>
                                </section>
                                <section className="section-setting mb-60">
                                    <h2 className="title"><Translate id="dashboard_profile.title_security" /></h2>
                                    <ExpansionPanel expanded={expanded === 'panel30'} onChange={this.handleChangePanel('panel30')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel30'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_password" /></Typography>
                                        </ExpansionPanelSummary>
                                        <form autoComplete="off" onSubmit={this.handleFormSubmit('panel30')}>
                                            <ExpansionPanelDetails className="panel-details">
                                                <div className="row">
                                                    <div className="col col-4">
                                                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.current_password ? true : false}>
                                                            <InputLabel htmlFor="current_password" className="form-label">
                                                                <Translate id="dashboard_profile.field_current_password" />
                                                            </InputLabel>
                                                            <Input id="current_password" value={this.state.current_password} onChange={this.handleChange('current_password')} className="form-input" type="password" />
                                                            {errorsData.current_password && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.current_password)}</FormHelperText>)}
                                                        </FormControl>
                                                    </div>
                                                    <div className="col col-4">
                                                        <FormControl className={classnames('form-control form-control-password', 'strength-' + new_password_strength_score, {'has-error': errorsData.new_password ? true : false})} fullWidth={true} margin="normal" error={errorsData.new_password ? true : false}>
                                                            <InputLabel htmlFor="new_password" className="form-label">
                                                                <Translate id="dashboard_profile.field_new_password" />
                                                            </InputLabel>
                                                            <Input id="new_password" value={this.state.new_password} onChange={this.handleChange('new_password')} className="form-input" type="password" />
                                                            {errorsData.new_password && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.new_password)}</FormHelperText>)}
                                                            {(new_password_strength_note !== '' && this.state.new_password !== '') && <span className="password-strength-note"><Translate id="dashboard_profile.password_strength" /> {this.props.translate('dashboard_profile.' + new_password_strength_note)}</span>}
                                                        </FormControl>
                                                    </div>
                                                    <div className="col col-4">
                                                        <FormControl className="form-control" fullWidth={true} margin="normal" error={errorsData.new_password_confirmation ? true : false}>
                                                            <InputLabel htmlFor="new_password_confirmation" className="form-label">
                                                                <Translate id="dashboard_profile.field_new_password_confirmation" />
                                                            </InputLabel>
                                                            <Input id="new_password_confirmation" value={this.state.new_password_confirmation} onChange={this.handleChange('new_password_confirmation')} className="form-input" type="password" />
                                                            {errorsData.new_password_confirmation && (<FormHelperText className="form-helper">{this.props.translate('dashboard_profile.' + errorsData.new_password_confirmation)}</FormHelperText>)}
                                                        </FormControl>
                                                    </div>
                                                </div>
                                            </ExpansionPanelDetails>
                                            <Divider />
                                            <ExpansionPanelActions>
                                                {updateProfileLoading ? (
                                                    <LoadingSpinner />
                                                ) : (
                                                    <Button variant="contained" color="primary" size="medium" className="btn-submit" type="submit" disabled={updateProfileLoading}>
                                                        <Translate id="dashboard_profile.button_update" />
                                                    </Button>
                                                )}
                                            </ExpansionPanelActions>
                                        </form>
                                    </ExpansionPanel>
                                    <ExpansionPanel expanded={expanded === 'panel31'} onChange={this.handleChangePanel('panel31')} className={classnames('expansion-panel', {
                                        'expanded': (expanded === 'panel31'),
                                    })}>
                                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                                            <Typography className="panel-heading"><Translate id="dashboard_profile.panel_title_login_history" /></Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails className="panel-details">
                                            <Typography>
                                                <Translate id="dashboard_profile.notice_account_activities" /> <Link to={this.props.translate('routes.contact')}><Translate id="dashboard_profile.contact_us" /></Link>.
                                            </Typography>
                                            {(Array.isArray(profile.login_history) && profile.login_history.length > 0) &&
                                                <List>
                                                    {profile.login_history.map(function(history, index) {
                                                        let date = moment(history.date, 'YYYY-MM-DD H:i:s').format(dateFormat);
                                                        let icon = <DevicesOtherIcon />;

                                                        switch (history.type) {
                                                            case 'mobile':
                                                                icon = <SmartphoneIcon />;
                                                                break;
                                                            case 'tablet':
                                                                icon = <TabletIcon />;
                                                                break;
                                                            case 'desktop':
                                                                icon = <DesktopIcon />;
                                                                break;
                                                            case 'laptop':
                                                                icon = <LaptopIcon />;
                                                                break;
                                                            default:
                                                                break;
                                                        }

                                                        return (
                                                            <ListItem key={index}>
                                                                <Avatar>
                                                                    {icon}
                                                                </Avatar>
                                                                <ListItemText primary={history.ua} secondary={date}/>
                                                            </ListItem>
                                                        );
                                                    })}
                                                </List>
                                            }
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                </section>
                            </Fragment>
                        )}
                    </div>
                </div>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    open={this.state.openSnackbarSuccess}
                    autoHideDuration={5000}
                    onClose={this.handleCloseSnackbar}
                    ContentProps={{
                        'aria-describedby': 'message-success',
                    }}
                    message={<span id="message-success"><Translate id="dashboard_profile.notice_profile_updated" /></span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            className="close"
                            onClick={this.handleCloseSnackbar}
                        >
                            <CloseIcon />
                        </IconButton>,
                    ]}
                />
            </Fragment>
        );
    }
}

DashboardProfileContainer.propTypes = {
    getCurrentUserProfile: PropTypes.func.isRequired,
    updateCurrentuserProfile: PropTypes.func.isRequired,
    getSchoolsDropdown: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    dashboard: state.dashboard,
    errors: state.dashboard.updateProfileErrors,
    schools: state.schools,
    currentLanguage: getActiveLanguage(state.localize).code,
});

export default withRouter(connect(mapStateToProps, {getCurrentUserProfile, updateCurrentuserProfile, getSchoolsDropdown})(withLocalize(DashboardProfileContainer)));



// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Profile/DashboardProfileContainer.js